import {AxiosResponse} from 'axios';
import {LearningPathStepTemp} from 'utils/types/learningPath';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';

type UserLearningPathRoutes = '/details' | '';

export const fetchLearningPathService = (
  learningPathUserInstanceId?: number,
  stepOrder?: number,
  route: UserLearningPathRoutes = '',
) =>
  letrusAPI(
    `/api/v1/new_learning_path_user_instances/${
      learningPathUserInstanceId ?? ''
    }${route}${learningPathUserInstanceId || route ? '/' : ''}`,
    {
      params: {
        step_number: stepOrder,
        limit: 60,
      },
    },
  );

export const fetchLearningPathDetailsService = (
  learningPathUserInstanceId: number,
  stepOrder?: number,
): Promise<AxiosResponse<LearningPathStepTemp>> =>
  letrusAPI(
    `/api/v1/new_learning_path_user_instances/${learningPathUserInstanceId}/details/`,
    {
      params: {
        step_number: stepOrder,
      },
    },
  );

export const finishPedagogicalContentStepService = (
  learningPathUserInstanceId: number | string,
) =>
  letrusAPI(
    `/api/v1/new_learning_path_user_instances/${learningPathUserInstanceId}/finish_pedagogical_step/`,
    {
      method: 'post',
    },
  );

export const viewLearningPathCSATService = (
  learningPathUserInstanceId: number | string,
  stepNumber?: number,
  started?: string,
) =>
  letrusAPI(
    `/api/v1/new_learning_path_user_instances/${learningPathUserInstanceId}/view_opinion/`,
    {
      method: 'post',
      data: {step_number: stepNumber, started},
    },
  );
